var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvailabilityConfirmation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 42H46V36H42V42H36V46H42V52H46V46H52V42Z",
    fill: "#48A14D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 60C35.2 60 28 52.8 28 44C28 35.2 35.2 28 44 28C52.8 28 60 35.2 60 44C60 52.8 52.8 60 44 60ZM44 32C37.4 32 32 37.4 32 44C32 50.6 37.4 56 44 56C50.6 56 56 50.6 56 44C56 37.4 50.6 32 44 32Z",
    fill: "#48A14D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56 12C56 9.8 54.2 8 52 8H44V4H40V8H24V4H20V8H12C9.8 8 8 9.8 8 12V52C8 54.2 9.8 56 12 56H24V52H12V12H20V16H24V12H40V16H44V12H52V24H56V12Z",
    fill: "#48A14D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailabilityConfirmation);
export default __webpack_public_path__ + "static/media/availabilityConfirmation.154c88ec47da6b23504097a754a7ee5f.svg";
export { ForwardRef as ReactComponent };